// extracted by mini-css-extract-plugin
export default {"base":"Content_base__o5Gyp"};